module.exports = __webpack_public_path__ + "img/int2_mob.030c7205.jpg";;
if (typeof window !== 'undefined') {
(window.__IMAGE_SIZES__ || (window.__IMAGE_SIZES__ = {}))[module.exports] = {"width":810,"height":525,"variants":[{"file":"img/int2_mob-480w.9695ef653df3.webp","width":480},{"file":"img/int2_mob-810w.c537376e4b66.webp","width":810}]};
}